export default "__VITE_ASSET__ac20e1c2__"